import Component from './Page.vue';

export default {
  install(Vue) {
    Vue.component('BkfPage', Component);
  },
};
